<template>
    <div>
        <div class="search-group">
            <!--<span>订单编号：</span>
            <a-input
                v-model="params.accountId"
                size="small"
                style="width: 200px; height: 40px"
            />
            <a-button @click="handleSearch" type="primary" style="height:40px;width:80px;margin-left:20px">查询</a-button>
            -->
            <div class="page_search">
                <search-com :searchData="searchData" @search="handleSearch"></search-com>
            </div>
        </div>

        <a-modal
            :bodyStyle="{height:'160px'}"
            :width="280"
            v-model="isVisible"
            title="扫码支付"
            @ok="handleCancel"
            @cancel="handleCancel"
            :closable="false"
        >
            <div v-if="isVisible" class="qrcode" id="qrCodeUrl" ref="qrCodeUrl"></div>
        </a-modal>

        <Invoice :isVisible="visible" :info="info" @close="visible = false" @show="visible = true" />

        <template>
            <a-table
                :columns="columns"
                :data-source="data"
                :pagination="pagination"
                @change="handleTableChange"
                style="background:white;padding:50px"
            >
                <span slot="orderType" slot-scope="data">{{$getters.orderType(data)}}</span>
                <a slot="operation" slot-scope="data, record">
                    <!-- <a-button @click="goToDetail(record)">详情</a-button> -->
                    <span @click="goToDetail(record)" class="ml10">
                        <a>详情</a>
                    </span>
                    <p @click="handleShowPaycode(data.orderNo)" class="mr10">
                        <a>支付码</a>
                    </p>
                </a>
                <span slot="status" slot-scope="data">{{$getters.orderStatus(data)}}</span>
                <span slot="authStatus" slot-scope="data">{{$getters.authStatus(data)}}</span>
                <span
                    slot="invoiceStatus"
                    slot-scope="data,record"
                    @click="handleInvoice(data,record)"
                >
                    <a>{{$getters.invoiceStatus(data)}}</a>
                </span>
                <span slot="paymentChannel" slot-scope="data">{{$getters.payWay(data)}}</span>
            </a-table>
        </template>
    </div>
</template>

<script>
import searchCom from "../../../components/Search.vue";
import Invoice from "../../../components/Invoice/index";

import QRCode from "qrcodejs2";

const columns = [
    {
        title: "订单编号",
        dataIndex: "orderNo",
        key: "orderNo"
    },
    {
        title: "订单类型",
        dataIndex: "orderType",
        scopedSlots: { customRender: "orderType" },
        key: "orderType"
    },
    {
        title: "用户手机号",
        dataIndex: "mobileNo",
        key: "mobileNo"
    },
    {
        title: "实名",
        dataIndex: "authStatus",
        key: "authStatus",
        scopedSlots: { customRender: "authStatus" }
    },
    {
        title: "服务商",
        dataIndex: "providerName",
        key: "providerName"
    },
    // {
    //     title: "产品详情",
    //     dataIndex: "accountId",
    //     key:"accountId"
    // },
    {
        title: "支付方式",
        dataIndex: "paymentChannel",
        key: "paymentChannel",
        scopedSlots: { customRender: "paymentChannel" }
    },
    {
        title: "创建时间",
        dataIndex: "createTime",
        key: "createTime"
    },
    {
        title: "支付时间",
        dataIndex: "payTime",
        key: "payTime"
    },
    {
        title: "支付状态",
        dataIndex: "status",
        key: "status",
        scopedSlots: { customRender: "status" }
    },
    {
        title: "应付金额",
        dataIndex: "payableAmount",
        key: "payableAmount"
    },
    {
        title: "优惠金额",
        dataIndex: "offAmount",
        key: "offAmount"
    },
    {
        title: "实付金额",
        dataIndex: "paymentAmount",
        key: "paymentAmount"
    },
    {
        title: "发票状态",
        dataIndex: "invoiceStatus",
        key: "invoiceStatus",
        scopedSlots: { customRender: "invoiceStatus" }
    },
    // {
    //     title: "协议状态",
    //     dataIndex: "accountId",
    //     key:"accountId"
    // },
    {
        title: "操作",
        ellipsis: true,
        scopedSlots: { customRender: "operation" }
    }
];

export default {
    data() {
        return {
            data: [],
            columns,
            params: { pageNum: 1, pageSize: 10 },
            pagination: {
                total: 0,
                pageSize: 10, //每页中显示10条数据
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"], //每页中显示的数据
                showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
            },
            searchData: [],
            visible: false,
            info: {},
            isVisible: false
        };
    },
    components: {
        searchCom,
        Invoice
    },
    methods: {
        handleCancel() {
            this.isVisible = false;
        },
        creatQrCode(url) {
            var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: url,
                width: 100,
                height: 100,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H
            });
        },
        handleShowPaycode(data) {
            this.$api.orders.getPayCode({ orderNo: data }).then(r => {
                if (!r.result) {
                    this.$message.error(r.message);
                } else if (r.result.url && r.message !== "订单已过期") {
                    this.isVisible = true;
                    console.log(r.result.url);
                    this.$nextTick(() => {
                        this.creatQrCode(r.result.url);
                    });
                } else {
                }
            });
        },
        handleInvoice(data, record) {
            console.log(data);
            if (data !== 0) {
                return;
            }
            this.visible = true;
            this.info = record;
        },
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.params.pageNum = pagination.current;
            this.params.pageSize = pagination.pageSize;
            this.getList();
        },
        goToDetail(t) {
            this.$emit("ondetail", "Detail", t.orderNo);
        },
        getList() {
            this.$api.customerManage
                .myCustomerOrderList(this.params)
                .then(response => {
                    this.data = response.result.list;
                    this.pagination.total = parseInt(response.result.total);
                });
        },
        handleSearch(filter) {
            // if(this.params.accountId){
            //     this.params.accountId = Number(this.params.accountId)
            // }
            // console.log(this.params)
            const condition = {
                orderNo: filter.orderNo,
                orderType: filter.orderType,
                mobileNo: filter.mobileNo,
                providerName: filter.providerName,
                paymentChannel: filter.paymentChannel,
                status: filter.status,
                payTimeBegin: this.$utils.dateRangeFormat(
                    filter.payTime,
                    "begin"
                ),
                payTimeEnd: this.$utils.dateRangeFormat(filter.payTime, "end"),
                createTimeBegin: this.$utils.dateRangeFormat(
                    filter.createTime,
                    "begin"
                ),
                createTimeEnd: this.$utils.dateRangeFormat(
                    filter.createTime,
                    "end"
                )
            };
            this.params = Object.assign(this.params, condition);
            this.getList();
        },
        searchDataInit() {
            // 初始化搜索条件
            this.updateSearchData();
        },
        updateSearchData() {
            this.searchData = [
                {
                    type: "input",
                    label: "订单编号",
                    attr: "orderNo",
                    value: ""
                },
                {
                    type: "select",
                    label: "订单类型",
                    attr: "orderType",
                    option: [{ value: "", label: "请选择" }].concat(
                        this.$selectOptions.orderType
                    ),
                    value: ""
                },
                {
                    type: "input",
                    label: "用户手机号",
                    attr: "mobileNo",
                    value: ""
                },
                {
                    type: "input",
                    attr: "providerName",
                    label: "服务商",
                    value: ""
                },
                {
                    type: "select",
                    label: "支付方式",
                    attr: "paymentChannel",
                    option: [{ value: "", label: "请选择" }].concat(
                        this.$selectOptions.payWay
                    ),
                    value: ""
                },
                {
                    type: "select",
                    label: "支付状态",
                    attr: "status",
                    option: [{ value: "", label: "请选择" }].concat(
                        this.$selectOptions.orderStatus
                    ),
                    value: ""
                },
                {
                    type: "rangePicker",
                    attr: "payTime",
                    label: "支付时间",
                    value: []
                },
                {
                    type: "rangePicker",
                    attr: "createTime",
                    label: "创建时间",
                    value: []
                }
            ];
        }
    },
    mounted() {
        this.getList();
        this.searchDataInit();
    }
};
</script>

<style scoped>
.search-group {
    margin-bottom: 10px;
    height: 280px;
    background: white;
    display: flex;
    align-items: center;
    padding: 20px;
}
</style>
